module.exports = __webpack_public_path__ + "img/pink-4.92d08ff3.svg";